document.addEventListener("DOMContentLoaded", () => {

    let imagesliderSwipers = document.getElementsByClassName('imageslider-swiper');

    for (let i = 0; i < imagesliderSwipers.length; i++) {

        let swiperElement = imagesliderSwipers[i];

        let swiperID = '#' + swiperElement.id;

        const swiper = new Swiper(swiperID, {
            direction: 'horizontal',
            loop: true,
            autoplay: {
                delay: 0,
            },
            speed: 6000,
            slidesPerView: 2,
            spaceBetween: 0,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                },
                1200: {
                    slidesPerView: 6,
                },
            }
        });

    }
});
